import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const translations = {
  fr: {
    _dir: "ltr",
    brand_tagline: "De la décompression au mouvement actif.",
    nav_features: "Fonctions", nav_pros: "Professionnels", nav_patients: "Patients",
    nav_journey: "Parcours SpinaTech", nav_contact: "Contact", nav_login: "Connexion",
    nav_patient_access: "Accès patient",
    hero_title: "De la décompression au mouvement actif",
    hero_sub: "Prescrivez, expliquez et suivez les exercices thérapeutiques de vos patients, au cabinet comme à domicile.",
    cta_start: "Accéder à l'application", cta_demo: "Voir une démo",
    login: "Connexion", email: "Courriel", password: "Mot de passe",
    login_btn: "Se connecter", forgot: "Mot de passe oublié ?",
    dashboard: "Tableau de bord", patients: "Patients", exercises: "Exercices",
    programs: "Programmes", templates: "Modèles", messages: "Messagerie",
    hilldt: "Parcours Hill DT", clinics: "Cabinets", users: "Utilisateurs",
    audit: "Journaux d'audit", settings: "Paramètres", logout: "Déconnexion",
    welcome: "Bienvenue", my_patients: "Mes patients", to_reeval: "À réévaluer",
    unread: "Non lus", new_patient: "Nouveau patient", search: "Rechercher",
    save: "Enregistrer", cancel: "Annuler", create: "Créer", edit: "Modifier",
    archive: "Archiver", close: "Fermer", loading: "Chargement…",
    first_name: "Prénom", last_name: "Nom", birth_date: "Date de naissance",
    phone: "Téléphone", address: "Adresse", region: "Wilaya / Région", lang: "Langue préférée",
    diagnosis: "Diagnostic", reason: "Motif de consultation", precautions: "Précautions",
    clinical_context: "Contexte clinique", identity: "Identité",
    notes: "Notes cliniques", consents: "Consentements", tracking: "Suivi",
    add_note: "Ajouter une note", note_content: "Contenu de la note",
    exercise_library: "Bibliothèque d'exercices", new_exercise: "Nouvel exercice",
    category: "Catégorie", difficulty: "Difficulté", objective: "Objectif",
    instructions: "Consignes", sharing: "Niveau de partage",
    sets: "Séries", reps: "Répétitions", duration: "Durée", frequency: "Fréquence", rest: "Repos",
    build_program: "Construire un programme", assign: "Prescrire", prescribe: "Prescrire le programme",
    program_goal: "Objectif du programme", reeval_date: "Date de réévaluation",
    add_exercise: "Ajouter un exercice", download_pdf: "Télécharger le PDF", show_qr: "Code QR",
    today_program: "Programme du jour", to_do: "À effectuer", done: "Terminé",
    my_progress: "Ma progression", next_reeval: "Prochaine réévaluation",
    documents: "Documents", report_difficulty: "Signaler une difficulté",
    start: "Commencer", finish: "Terminé", pain_before: "Douleur avant", pain_after: "Douleur après",
    difficulty_level: "Difficulté", reps_done: "Répétitions réalisées", comment: "Commentaire",
    start_position: "Position de départ", mistakes: "Erreurs à éviter",
    emergency_notice: "La messagerie SpinaGo ne doit pas être utilisée en cas d'urgence médicale.",
    demo_data: "DONNÉES DE DÉMONSTRATION",
    hilldt_disabled: "Le module Hill DT est désactivé pour ce cabinet.",
    hilldt_no_reco: "SpinaGo ne suggère aucun paramètre. Le professionnel saisit et approuve toutes les décisions cliniques.",
    active_program: "Programme actif", no_program: "Aucun programme actif pour le moment.",
    send: "Envoyer", message_placeholder: "Écrire un message…",
    beginner: "Débutant", intermediate: "Intermédiaire", advanced: "Avancé",
    high_pain_alert: "Hausse de douleur rapportée", adherence: "Adhésion",
    profile: "Profil", change_password: "Changer le mot de passe",
    stat_clinics: "Cabinets actifs", stat_accounts: "Comptes", stat_pros: "Professionnels",
    stat_active_programs: "Programmes actifs", recent_activity: "Activité récente",
    role_superadmin: "Super administrateur", role_clinic_admin: "Administrateur de cabinet",
    role_professional: "Professionnel de santé", role_assistant: "Assistant(e)", role_patient: "Patient",
    footer_legal: "Une validation juridique, une analyse de protection des renseignements et un audit de sécurité sont requis avant toute utilisation avec de véritables patients.",
    privacy: "Confidentialité", terms: "Conditions", features: "Fonctions",
    no_data: "Aucune donnée pour le moment.",
  },
  en: {
    _dir: "ltr",
    brand_tagline: "From decompression to active movement.",
    nav_features: "Features", nav_pros: "Professionals", nav_patients: "Patients",
    nav_journey: "SpinaTech Journey", nav_contact: "Contact", nav_login: "Log in",
    nav_patient_access: "Patient access",
    hero_title: "From decompression to active movement",
    hero_sub: "Prescribe, explain and track your patients' therapeutic exercises, at the clinic and at home.",
    cta_start: "Open the app", cta_demo: "See a demo",
    login: "Log in", email: "Email", password: "Password",
    login_btn: "Sign in", forgot: "Forgot password?",
    dashboard: "Dashboard", patients: "Patients", exercises: "Exercises",
    programs: "Programs", templates: "Templates", messages: "Messages",
    hilldt: "Hill DT Journey", clinics: "Clinics", users: "Users",
    audit: "Audit logs", settings: "Settings", logout: "Log out",
    welcome: "Welcome", my_patients: "My patients", to_reeval: "To re-evaluate",
    unread: "Unread", new_patient: "New patient", search: "Search",
    save: "Save", cancel: "Cancel", create: "Create", edit: "Edit",
    archive: "Archive", close: "Close", loading: "Loading…",
    first_name: "First name", last_name: "Last name", birth_date: "Date of birth",
    phone: "Phone", address: "Address", region: "Region", lang: "Preferred language",
    diagnosis: "Diagnosis", reason: "Reason for consultation", precautions: "Precautions",
    clinical_context: "Clinical context", identity: "Identity",
    notes: "Clinical notes", consents: "Consents", tracking: "Tracking",
    add_note: "Add note", note_content: "Note content",
    exercise_library: "Exercise library", new_exercise: "New exercise",
    category: "Category", difficulty: "Difficulty", objective: "Objective",
    instructions: "Instructions", sharing: "Sharing level",
    sets: "Sets", reps: "Reps", duration: "Duration", frequency: "Frequency", rest: "Rest",
    build_program: "Build a program", assign: "Prescribe", prescribe: "Prescribe program",
    program_goal: "Program goal", reeval_date: "Re-evaluation date",
    add_exercise: "Add exercise", download_pdf: "Download PDF", show_qr: "QR code",
    today_program: "Today's program", to_do: "To do", done: "Done",
    my_progress: "My progress", next_reeval: "Next re-evaluation",
    documents: "Documents", report_difficulty: "Report a difficulty",
    start: "Start", finish: "Finish", pain_before: "Pain before", pain_after: "Pain after",
    difficulty_level: "Difficulty", reps_done: "Reps done", comment: "Comment",
    start_position: "Starting position", mistakes: "Mistakes to avoid",
    emergency_notice: "SpinaGo messaging must not be used in a medical emergency.",
    demo_data: "DEMONSTRATION DATA",
    hilldt_disabled: "The Hill DT module is disabled for this clinic.",
    hilldt_no_reco: "SpinaGo suggests no parameters. The professional enters and approves all clinical decisions.",
    active_program: "Active program", no_program: "No active program yet.",
    send: "Send", message_placeholder: "Write a message…",
    beginner: "Beginner", intermediate: "Intermediate", advanced: "Advanced",
    high_pain_alert: "Reported pain increase", adherence: "Adherence",
    profile: "Profile", change_password: "Change password",
    stat_clinics: "Active clinics", stat_accounts: "Accounts", stat_pros: "Professionals",
    stat_active_programs: "Active programs", recent_activity: "Recent activity",
    role_superadmin: "Super administrator", role_clinic_admin: "Clinic administrator",
    role_professional: "Health professional", role_assistant: "Assistant", role_patient: "Patient",
    footer_legal: "Legal validation, a privacy impact assessment and a security audit are required before any use with real patients.",
    privacy: "Privacy", terms: "Terms", features: "Features",
    no_data: "No data yet.",
  },
  ar: {
    _dir: "rtl",
    brand_tagline: "من تخفيف الضغط إلى الحركة النشطة.",
    nav_features: "الميزات", nav_pros: "المهنيون", nav_patients: "المرضى",
    nav_journey: "مسار SpinaTech", nav_contact: "اتصل بنا", nav_login: "تسجيل الدخول",
    nav_patient_access: "دخول المريض",
    hero_title: "من تخفيف الضغط إلى الحركة النشطة",
    hero_sub: "صِف واشرح وتابع التمارين العلاجية لمرضاك، في العيادة وفي المنزل.",
    cta_start: "فتح التطبيق", cta_demo: "عرض تجريبي",
    login: "تسجيل الدخول", email: "البريد الإلكتروني", password: "كلمة المرور",
    login_btn: "دخول", forgot: "نسيت كلمة المرور؟",
    dashboard: "لوحة التحكم", patients: "المرضى", exercises: "التمارين",
    programs: "البرامج", templates: "القوالب", messages: "الرسائل",
    hilldt: "مسار Hill DT", clinics: "العيادات", users: "المستخدمون",
    audit: "سجلات التدقيق", settings: "الإعدادات", logout: "تسجيل الخروج",
    welcome: "مرحباً", my_patients: "مرضاي", to_reeval: "لإعادة التقييم",
    unread: "غير مقروء", new_patient: "مريض جديد", search: "بحث",
    save: "حفظ", cancel: "إلغاء", create: "إنشاء", edit: "تعديل",
    archive: "أرشفة", close: "إغلاق", loading: "جارٍ التحميل…",
    first_name: "الاسم", last_name: "اللقب", birth_date: "تاريخ الميلاد",
    phone: "الهاتف", address: "العنوان", region: "الولاية / المنطقة", lang: "اللغة المفضلة",
    diagnosis: "التشخيص", reason: "سبب الاستشارة", precautions: "الاحتياطات",
    clinical_context: "السياق السريري", identity: "الهوية",
    notes: "الملاحظات السريرية", consents: "الموافقات", tracking: "المتابعة",
    add_note: "إضافة ملاحظة", note_content: "محتوى الملاحظة",
    exercise_library: "مكتبة التمارين", new_exercise: "تمرين جديد",
    category: "الفئة", difficulty: "الصعوبة", objective: "الهدف",
    instructions: "التعليمات", sharing: "مستوى المشاركة",
    sets: "المجموعات", reps: "التكرارات", duration: "المدة", frequency: "التكرار", rest: "الراحة",
    build_program: "إنشاء برنامج", assign: "وصف", prescribe: "وصف البرنامج",
    program_goal: "هدف البرنامج", reeval_date: "تاريخ إعادة التقييم",
    add_exercise: "إضافة تمرين", download_pdf: "تنزيل PDF", show_qr: "رمز QR",
    today_program: "برنامج اليوم", to_do: "للتنفيذ", done: "تم",
    my_progress: "تقدمي", next_reeval: "إعادة التقييم القادمة",
    documents: "المستندات", report_difficulty: "الإبلاغ عن صعوبة",
    start: "ابدأ", finish: "إنهاء", pain_before: "الألم قبل", pain_after: "الألم بعد",
    difficulty_level: "الصعوبة", reps_done: "التكرارات المنجزة", comment: "تعليق",
    start_position: "وضعية البداية", mistakes: "أخطاء يجب تجنبها",
    emergency_notice: "لا يجب استخدام رسائل SpinaGo في حالات الطوارئ الطبية.",
    demo_data: "بيانات تجريبية",
    hilldt_disabled: "وحدة Hill DT معطلة لهذه العيادة.",
    hilldt_no_reco: "لا يقترح SpinaGo أي معلمات. يقوم المهني بإدخال جميع القرارات السريرية والموافقة عليها.",
    active_program: "البرنامج النشط", no_program: "لا يوجد برنامج نشط حالياً.",
    send: "إرسال", message_placeholder: "اكتب رسالة…",
    beginner: "مبتدئ", intermediate: "متوسط", advanced: "متقدم",
    high_pain_alert: "زيادة في الألم المُبلغ عنه", adherence: "الالتزام",
    profile: "الملف الشخصي", change_password: "تغيير كلمة المرور",
    stat_clinics: "العيادات النشطة", stat_accounts: "الحسابات", stat_pros: "المهنيون",
    stat_active_programs: "البرامج النشطة", recent_activity: "النشاط الأخير",
    role_superadmin: "المدير العام", role_clinic_admin: "مدير العيادة",
    role_professional: "أخصائي صحي", role_assistant: "مساعد", role_patient: "مريض",
    footer_legal: "يلزم إجراء تحقق قانوني وتقييم لحماية البيانات وتدقيق أمني قبل أي استخدام مع مرضى حقيقيين.",
    privacy: "الخصوصية", terms: "الشروط", features: "الميزات",
    no_data: "لا توجد بيانات بعد.",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("spinago_lang") || "fr");

  useEffect(() => {
    localStorage.setItem("spinago_lang", lang);
    const dir = translations[lang]._dir;
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const t = useCallback((key) => translations[lang][key] || translations.fr[key] || key, [lang]);
  const dir = translations[lang]._dir;

  return (
    <I18nContext.Provider value={{ lang, setLang, t, dir }}>{children}</I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
export const LANGS = [
  { code: "fr", label: "Français" },
  { code: "ar", label: "العربية" },
  { code: "en", label: "English" },
];
